export const olemiss_valid_email_extensions = [
    'olemiss.edu',
    'go.olemiss.edu',
    'business.olemiss.edu',
    'bus.olemiss.edu',
    'law.olemiss.edu',
    'pharmacy.olemiss.edu',
    'rx.olemiss.edu',
    'egrove.olemiss.edu',
    'ummail.olemiss.edu',
    'my.olemiss.edu',
    'umc.edu',
    // Add more emails extensions here
];